import { Response, apiAbortController } from '@ui/src';
import api from '../../../../api/api';
import { Agreement, AgreementBody, UploadResponse } from '../../types';

export const agreementApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAgreements: build.query<Response<Agreement>, string>({
      query: (query) => ({
        url: `/v1/agreements${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAgreement: build.query<{ data: Agreement }, string>({
      query: (id) => ({
        url: `/v1/agreements/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    employeesUpload: build.mutation({
      async queryFn(file: File, _queryApi, _extraOptions, fetchWithBQ) {
        const formData = new FormData();
        formData.append('files', file);

        const response = (await fetchWithBQ({
          url: '/v1/uploads',
          method: 'POST',
          body: formData,
        })) as { data: UploadResponse[] };

        return response;
      },
    }),
    getEmployeesAgreementFile: build.query<{ data: any }, string>({
      query: (id) => ({
        url: `/v1/agreements/${id}/file`,
        responseHandler: (response) => response.blob(),
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    addAgreement: build.mutation<
      {
        data: Agreement;
      },
      AgreementBody
    >({
      query: (body) => ({
        url: '/v1/agreements',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    changeAgreementsStatus: build.mutation<any, string[]>({
      query: (data) => ({
        url: '/v1/agreements/batch-archive',
        method: 'PUT',
        body: {
          ids: data,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetAgreementsQuery,
  useLazyGetAgreementQuery,
  useEmployeesUploadMutation,
  useLazyGetEmployeesAgreementFileQuery,
  useAddAgreementMutation,
  useChangeAgreementsStatusMutation,
} = agreementApi;

export const {
  endpoints: {
    getAgreements,
    getAgreement,
    employeesUpload,
    getEmployeesAgreementFile,
    addAgreement,
    changeAgreementsStatus,
  },
} = agreementApi;
